import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Image } from '@/components/client';
import { Rating } from '@/components/molecule/Rating';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { ReviewDetailContent } from '../../ReviewDetailContent';
interface ReviewListItemProps {
  reviewId: number;
  productThumbnailUrl: string;
  productName: string;
  rating: number;
  reviewContent: string;
}
export const ReviewListItem = t0 => {
  const $ = _c(24);
  const {
    reviewId,
    productThumbnailUrl,
    productName,
    rating,
    reviewContent
  } = t0;
  const isPhotoReview = !!productThumbnailUrl;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex w-fit items-center gap-16 rounded-large bg-Gray-white p-12");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isPhotoReview || $[2] !== reviewId) {
    t2 = () => {
      openResponsiveDialog({
        component: ReviewDetailContent,
        modalHeader: isPhotoReview ? "\uD3EC\uD1A0\uD6C4\uAE30" : "\uD6C4\uAE30",
        className: {
          modal: "max-w-[900px]"
        },
        props: {
          reviewId
        },
        drawerNoPadding: true
      });
    };
    $[1] = isPhotoReview;
    $[2] = reviewId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== productName || $[5] !== productThumbnailUrl) {
    t3 = <div className="relative size-104 overflow-hidden rounded-medium"><Image src={productThumbnailUrl} fill={true} alt={productName} className="object-cover" sizes="104px" /></div>;
    $[4] = productName;
    $[5] = productThumbnailUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("flex w-237 flex-col gap-4");
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== rating) {
    t5 = <Rating value={rating} size={16} />;
    $[8] = rating;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("line-clamp-1 text-start font-600 text-Gray-900 typo-body4");
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== productName) {
    t7 = <div><p className={t6}>{productName}</p></div>;
    $[11] = productName;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("font-400 text-Gray-600 typo-body4");
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== reviewContent) {
    t9 = <div className={t8}><span className="line-clamp-2 w-full text-left">{reviewContent}</span></div>;
    $[14] = reviewContent;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t7 || $[18] !== t9) {
    t10 = <div className={t4}>{t5}{t7}{t9}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t2 || $[22] !== t3) {
    t11 = <button type="button" className={t1} onClick={t2}>{t3}{t10}</button>;
    $[20] = t10;
    $[21] = t2;
    $[22] = t3;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};